/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field breakdown`)
};

const es_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose de campos`)
};

const de_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feldaufschlüsselung`)
};

const nl_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afbraak van velden`)
};

const fr_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décomposition des champs`)
};

const it_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suddivisione dei campi`)
};

const pt_br2_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhamento de campos`)
};

const pt_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decomposição de campos`)
};

const ja_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィールド分解`)
};

const zh_cr_fields_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字段解析`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_fields_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_fields_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_fields_title", locale)
	if (locale === "en") return en_cr_fields_title(inputs)
	if (locale === "es") return es_cr_fields_title(inputs)
	if (locale === "de") return de_cr_fields_title(inputs)
	if (locale === "nl") return nl_cr_fields_title(inputs)
	if (locale === "fr") return fr_cr_fields_title(inputs)
	if (locale === "it") return it_cr_fields_title(inputs)
	if (locale === "pt-BR") return pt_br2_cr_fields_title(inputs)
	if (locale === "pt") return pt_cr_fields_title(inputs)
	if (locale === "ja") return ja_cr_fields_title(inputs)
	return zh_cr_fields_title(inputs)
};